import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { Owned } from 'app/model/base/named';
import { ParameterConfig, IViolation } from 'shell-models-lib';
import { createParameterConfigurationValidator } from '../adapters/linkedservices/parameter-config.util';
import { copyMethodOptionValues } from 'app/shared/components/copy-method-setting/copy-method-setting.const';
import { dateFormatOptionValues, knownAdditionalProperties } from 'app/shared/components/copy-command-setting/copy-command-setting.const';
import { format, stringIsNullOrEmpty } from 'app/shared/utils/string.util';
import { dwSinkDisAllowedCopyCommand } from 'app/shared/utils/copy-method.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
export interface IColumnDefaultValue {
    columnName: string;
    defaultValue: string;
}

@Metamodel.model({
    display: [stringResources.CopyCommand]
})
export class CopyCommandSetting extends Owned {
    public static readonly MODEL: IModel;
    public static readonly DEFAULT_VALUES: IAttribute;
    public static readonly ADDITIONAL_OPTIONS: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'DEFAULT_VALUES',
        display: stringResources.CopyCommand_DefaultValues_Label,
        accepts: ['Object', 'Array'],
        constraint: {
            validator: CopyCommandSetting.validateDefaultValues
        }
    })
    public defaultValues: ParameterConfig[] = [];

    @Metamodel.attribute({
        templatable: true,
        association: 'ADDITIONAL_OPTIONS',
        display: stringResources.CopyCommand_AdditionalOptions_Label,
        accepts: ['Object', 'Array'],
        constraint: {
            validator: CopyCommandSetting.validateAdditionalOptions
        }
    })
    public additionalOptions: ParameterConfig[] = [];

    /* eslint-disable @typescript-eslint/no-explicit-any */
    private static validateDefaultValues(owner: any, settings: ParameterConfig[]): IViolation[] | undefined {
        let ownerModel: IModel;
        if (owner?.owner) {
            ownerModel = Metamodel.modelOf(owner.owner);
        }

        if (
            settings?.length > 0 &&
            owner?.owner &&
            (
                (owner.owner.copyMethod === copyMethodOptionValues.CopyCommand &&!dwSinkDisAllowedCopyCommand(owner.owner)) ||
                (__IS_FABRIC_DPE__ && ownerModel?.name === adfModelTypeMap.DataWarehouse.copySinkType)
            )
        ) {
            return createParameterConfigurationValidator()(owner, settings);
        }
        return undefined;
    }

    private static validateAdditionalOptions(owner: any, settings: ParameterConfig[]): IViolation[] | undefined {
        const violations: IViolation[] = [];
        let ownerModel: IModel;
        if (owner?.owner) {
            ownerModel = Metamodel.modelOf(owner.owner);
        }

        if (
            settings?.length > 0 &&
            owner?.owner &&
            (
                (owner.owner.copyMethod === copyMethodOptionValues.CopyCommand && !dwSinkDisAllowedCopyCommand(owner.owner)) ||
                (__IS_FABRIC_DPE__ && ownerModel?.name === adfModelTypeMap.DataWarehouse.copySinkType)
            )
        ) {
            const violationsInParameters = createParameterConfigurationValidator(true)(settings, settings);
            if (violationsInParameters && violationsInParameters.length > 0) {
                violations.push(...violationsInParameters);
            }
            if (violations.length > 0) {
                return violations;
            } else {
                settings.forEach((option, index) => {
                    if (option.name === knownAdditionalProperties.DATEFORMAT && !stringIsNullOrEmpty(option.value)
                        && [dateFormatOptionValues.DMY, dateFormatOptionValues.DYM, dateFormatOptionValues.MDY,
                        dateFormatOptionValues.MYD, dateFormatOptionValues.YMD, dateFormatOptionValues.YDM].indexOf(option.value) === -1) {
                        violations.push({
                            message: () => format(stringResources.CopyCommand_CopyMethod_CopyCommandAdditionalPropertiesErrorTemplate,
                                knownAdditionalProperties.DATEFORMAT, [dateFormatOptionValues.DMY, dateFormatOptionValues.DYM, dateFormatOptionValues.MDY,
                                dateFormatOptionValues.MYD, dateFormatOptionValues.YMD].join(', ') + ' ' + stringResources.Or + ' ' + dateFormatOptionValues.YDM),
                            context: {
                                field: 'value',
                                index
                            }
                        });
                    } else if (option.name === knownAdditionalProperties.IDENTITY_INSERT && !stringIsNullOrEmpty(option.value) && ['\'ON\'', '\'OFF\''].indexOf(option.value) === -1) {
                        violations.push({
                            message: () => format(stringResources.CopyCommand_CopyMethod_CopyCommandAdditionalPropertiesErrorTemplate,
                                knownAdditionalProperties.IDENTITY_INSERT, ['\'ON\'', '\'OFF\''].join(' ' + stringResources.Or + ' ')),
                            context: {
                                field: 'value',
                                index
                            }
                        });
                    }
                });
            }
        }
        return violations;
    }
}
